<template>
  <div>
    <div class="mobileHeaderWrap">
      <div class="sfLogoWrap">
        <router-link to="/"></router-link>
      </div>
      <div class="sfNavMobileButtonWrap">
        <button
          class="menuIcon"
          @click="navigatorOpen"
        />
      </div>
    </div>

    <transition name="sfNavMobile">
      <div v-show="active" class="sfNavMobileWrap">
        <div class="navWrap">
          <div class="sfLogoWrap">
            <router-link to="/"></router-link>
          </div>

          <nav class="sfNavigation">
            <ul>
              <router-link tag="li" :to="{path : '/sf/sunnyfactory'}">SUNNY FACTORY</router-link>
              <router-link tag="li" :to="{path : '/sf/portfolio'}">PORTFOLIO</router-link>
              <router-link tag="li" :to="{path : '/sf/contactus'}">CONTACT US</router-link>
            </ul>
          </nav>

          <div class="snsAndCopyRight">
            <div>
              <div class="snsWrap">
                <button class="shareplatBtn" @click="snsLocation('shareplat')"></button>
                <button class="instagramBtn" @click="snsLocation('instagram')"></button>
                <button class="facebookBtn" @click="snsLocation('facebook')"></button>
                <button class="twitterBtn" @click="snsLocation('twitter')"></button>
              </div>
              <div class="copyRightWrap">
                <strong class="copyRight">
                  Copyright © SunnyFactory<br/>
                  [factorysunny.com]<br/>
                  All Rights Reserved.
                </strong>
              </div>
            </div>
          </div>

        </div>
        <div class="overlay" v-if="active" @click="navigatorClose"/>

      </div>
    </transition>

  </div>

</template>

<script>
  import {mapState , mapMutations} from 'vuex';

  export default {
    name: "mobile-header",
    components: {
    },
    props: [],
    computed: {
      ...mapState('mobileNavStore' , ['active'])
    },
    watch: {},
    methods: {
      ...mapMutations('mobileNavStore' , ['SET__ACTIVE']),
      snsLocation(type) {
        const locationUrl = {
          instagram: 'https://www.instagram.com/jihoonlee1980/',
          facebook: 'https://www.facebook.com/SunnyFactory-149706582359643/',
          twitter: 'https://twitter.com/sunny9224',
          shareplat : 'https://shareplatform.net' ,
        }
        window.open(
          locationUrl[type],
          '_blank'
        );
      },
      navigatorOpen(e) {
        e.preventDefault();
        this.SET__ACTIVE(!this.active);
      },
      navigatorClose(e) {
        e.preventDefault();
        this.SET__ACTIVE(false);
      },
    },
    data() {
      return {
      }
    },
    created() {

    },
    updated() {

    },
    mounted() {

    },


  }
</script>

<style scoped lang="scss">
  @import '@/styles/Global.scss';

  .mobileHeaderWrap {
    display: none;
    width: 100%;
    height: 100px;
    //padding-top:3rem;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    background-color: #012937;
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    @include respond-to('medium') {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .sfLogoWrap {

      @include respond-to('medium') {
        width: 174px;
        height: 60px;
        background: url(https://d77k7si2heyyr.cloudfront.net/images/icons/sf-logo-horizontal.png) center no-repeat;
        background-size: contain;
        //margin-top:3rem;
      }
      @include respond-to('small') {
        width: 140px;
        height: 48px;
      }
      > a {
        display: flex;
        width: 100%;
        height: 100%;
      }
    }

    .sfNavMobileButtonWrap {
      display: none;
      @include respond-to('medium') {
        display: flex;
        position: absolute;
        left: 0;
        top:35px;
        width: 50px;
        height: 35px;
        margin-left: 1.5rem;
      }
      @include respond-to('small') {
        display: flex;
        position: absolute;
        left: 0;
        width: 35px;
        height: 25px;
        margin-left: 1.5rem;
      }
      > button.menuIcon {
        width: 100%;
        height: 100%;
        border: 0;
        @include respond-to('medium') {
          background: url(https://d77k7si2heyyr.cloudfront.net/images/icons/menu-bar.png) center no-repeat;
          background-size: 100%;
        }
      }
    }
  }

  .sfNavMobile-enter-active, .sfNavMobile-leave-active {
    transition: all .2s ease;
  }

  .sfNavMobile-enter, .sfNavMobile-leave-to {
    transform: translateX(-70%);
  }

  .sfNavMobileWrap {
    width: 100%;
    /*background: #00000029;*/
    height: 100%;
    position: absolute;
    //left: -260px;
    top: 0;
    z-index: 2;
    display: flex;
    //background-color:rgba(0,0,0,0.3);
    > .navWrap {
      height: 100%;
      width: 70%;
      background-color: #012937;
      box-shadow: inset -3px -1px 4px 0px rgb(9, 34, 45);
      display: flex;
      flex-flow: column wrap;
      .sfLogoWrap {
        //margin-top:1rem;
        width: 100%;
        height: 60px;
        background: url(https://d77k7si2heyyr.cloudfront.net/images/icons/sf-logo-horizontal.png) center no-repeat;
        background-size: contain;
        margin: 3.5rem 0;
        @include respond-to('small') {
          margin: 2rem 0;
        }
        //box-shadow: ;
        /*cursor:pointer;*/
        > a {
          display: flex;
          width: 100%;
          height: 100%;
        }
      }
      .sfNavigation {
        width: 75%;
        margin: 0 auto;
        > ul {
          > li {
            list-style: none;
            margin: 1rem 0;
            font-size: 1.3rem;
            color: #fff;
            cursor: pointer;
          }
        }
      }
      .snsAndCopyRight {
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-end;
        > div {
          width: 100%;
          height: 250px;
          .snsWrap {
            width: 60%;
            margin: 2rem auto;
            display: flex;
            justify-content: space-around;
            > button {
              width: 30px;
              height: 30px;
              border: none;
              cursor: pointer;
            }
            .shareplatBtn {
              background: url(https://d77k7si2heyyr.cloudfront.net/images/icons/shareplat-loaction.icon.png) center no-repeat;
            }
            .instagramBtn {
              background: url(https://d77k7si2heyyr.cloudfront.net/images/icons/instagram.png) center no-repeat;
            }
            .facebookBtn {
              background: url(https://d77k7si2heyyr.cloudfront.net/images/icons/facebook.png) center no-repeat;
            }
            .twitterBtn {
              background: url(https://d77k7si2heyyr.cloudfront.net/images/icons/twitter.png) center no-repeat;
            }
          }
          .copyRightWrap {
            width: 75%;
            margin: 0 auto;
            > strong.copyRight {
              color: #fff;
              font-weight: 200;
              font-size: 1rem;
            }
          }
        }
      }
    }
    > .overlay {
      width: 30%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/layouts/MobileHeader.vue